import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
    const { isAuthenticated, isSidebarOpen, user, ModuleRouteMap } = useAuth();
    const location = useLocation();

    // ✅ Hook must be called unconditionally
    const [openModule, setOpenModule] = useState(null);

    if (!isAuthenticated) return null;

    const userModules = user?.modules?.module_features || {};
    const sidebarClasses = isSidebarOpen ? 'sidebar-open' : 'sidebar-closed';

    const toggleModule = (moduleCode) => {
        setOpenModule(prev => prev === moduleCode ? null : moduleCode);
    };

    return (
        <aside id="app-sidebar" className={sidebarClasses}>
            <nav id="module-navigation">
                {Object.keys(ModuleRouteMap).map(moduleCode => {
                    const moduleConfig = ModuleRouteMap[moduleCode];
                    const moduleAccessFeatures = userModules[moduleCode];

                    // Modules with alwaysVisible bypass role/feature gating (e.g. Remy).
                    if (!moduleConfig.alwaysVisible && (!moduleAccessFeatures || moduleAccessFeatures.length === 0)) return null;

                    const isModuleOpen = openModule === moduleCode;

                    // Modules with externalUrl are direct links — no expansion needed.
                    if (moduleConfig.externalUrl) {
                        return (
                            <div key={moduleCode} className="nav-module">
                                <a
                                    href={moduleConfig.externalUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="module-title"
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                                >
                                    <span style={{ marginRight: '10px' }}>{moduleConfig.icon}</span>
                                    <span>{moduleConfig.name}</span>
                                </a>
                            </div>
                        );
                    }

                    return (
                        <div key={moduleCode} className="nav-module">
                            <h4
                                className="module-title"
                                onClick={() => toggleModule(moduleCode)}
                                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                            >
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '10px' }}>{moduleConfig.icon}</span>
                                    <span>{moduleConfig.name}</span>
                                </span>
                                <span>{isModuleOpen ? '▾' : '▸'}</span>
                            </h4>

                            <ul className={`nav-features ${isModuleOpen ? 'expanded' : 'collapsed'}`}>
                                {Object.keys(moduleConfig.features).map(featureKey => {
                                    const featureConfig = moduleConfig.features[featureKey];
                                    const featureCode  = featureConfig.featureCode || featureKey;
                                    const isAccessible = featureConfig.visibleWithModule
                                        ? (moduleAccessFeatures?.length ?? 0) > 0
                                        : moduleAccessFeatures?.includes(featureCode) ?? moduleConfig.alwaysVisible;
                                    if (!isAccessible) return null;
                                    const isActive = location.pathname === featureConfig.path;

                                    return (
                                        <li
                                            key={featureKey}
                                            style={{ paddingLeft: isModuleOpen ? '30px' : '10px', transition: 'padding-left 0.3s' }}
                                        >
                                            <Link
                                                to={featureConfig.path}
                                                className={isActive ? 'active' : ''}
                                            >
                                                <span className="feature-icon" style={{ marginRight: isSidebarOpen ? '10px' : '0' }}>
                                                    {featureConfig.icon}
                                                </span>
                                                <span>{featureConfig.name}</span>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>

                        </div>
                    );
                })}
            </nav>
        </aside>
    );
};

export default Sidebar;
